const events = require('../../scripts/events');

module.exports = {
  addressSearch: async ({ rootState, commit, dispatch }, address) => {
    const config = {
      method: 'get',
      url: 'locations',
      params: {
        address
      }
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
      events.pushEvent('view_store_list', response.data.locations, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
      commit('setResults', response.data.locations)
      commit('setPosition', response.data.position)
    }
    commit('setSearched', true)
  },
  coordSearch: async ({ rootState, commit, dispatch }, geolocation) => {
    const { latitude, longitude } = geolocation

    if (latitude && longitude) {
      const config = {
        method: 'get',
        url: `locations?lat=${latitude}&lng=${longitude}`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        const tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
        events.pushEvent('view_store_list', response.data.locations, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.menu, rootState.channel)
        
        commit('setResults', response.data.locations)
        commit('setPosition', response.data.position)
        commit('setSearched', true)

        return true
      }
      commit('setSearched', true)

      return false
    }

    return false
  },
}